import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './Actions';

interface IState {
    shownTab: string;
    loading: boolean;
    showSwapPlanOrdersModal: boolean;
    activeTab: string;
}

class ViewOrderPage extends React.Component<any, IState> {
    private _lastOrderIdToCheckForArchive: number = 0;

    constructor(props: any) {
        super(props);

        this.state = {
            shownTab: 'basic',
            loading: false,
            showSwapPlanOrdersModal: false,
            activeTab: ''
        };
    }

    componentDidMount() {
        let orderNumber = this.stripRouteHashFromOrderId(this.props.match.params.orderNumber);

        this.props.actions.getOrderIdByOrderNumber(orderNumber).then((result: any) => {
            this.props.history.push(`/orders/${result}`);
        });
    }

    stripRouteHashFromOrderId = (orderId: string, splitSymbol = '#'): string => {
        if (orderId.indexOf(splitSymbol) === -1) {
            let result = orderId;
            return result;
        }

        let hashIndex = orderId.indexOf(splitSymbol);
        let resultString = orderId.substring(0, hashIndex);
        let result = this.stripRouteHashFromOrderId(resultString, '?');
        return result;
    };

    UNSAFE_componentWillReceiveProps(nextProps) {}

    componentWillUnmount() {}

    render() {
        return null;
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {};
}

function mapDispatchToProps(dispatch: any): { actions: IActions } {
    return {
        actions: {
            getOrderIdByOrderNumber: (orderNumber: string): Promise<string> =>
                dispatch(Actions.getOrderIdByOrderNumber(orderNumber))
        }
    };
}

interface IActions {
    getOrderIdByOrderNumber: (orderNumber: string) => Promise<string>;
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewOrderPage));
